import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import WizardStep from '../../components/wizard/WizardStep'

@Module(
  {
    name: 'Wizard'
  }
)
export default class Wizard extends VuexModule {
  // #region Page

    page = 1;
    previousPage = 0;

    @Mutation
    private setPage (val: number) {
      this.previousPage = JSON.parse(JSON.stringify(this.page))
      this.page = val
    }

    @Action
    updatePage (val: number) {
      this.setPage(val)
    }

    // #endregion

    // #region Callback

    callback = false;

    @Mutation
    private setCallback (val: boolean) {
      this.callback = val
    }

		@Action
    updateCallback (val?: boolean) {
      this.setCallback(val || false)
    }

		// #endregion

		// #region Steps

    steps: WizardStep[] = [];

    @Mutation
    private setWizardSteps (val: WizardStep[]) {
      this.steps = val
    }

    @Action
    updateWizardSteps (val: WizardStep[]) {
      this.setWizardSteps(val)
    }

    // #endregion

    // #region Reset

    @Mutation
    private async resetStore () {
      this.steps = []
      this.page = 1
      this.previousPage = 0
    }

    @Action
    async reset () {
      await this.resetStore()
    }

  // #endregion
}
